import { useQuery } from '@tanstack/react-query';
import { call } from '@/lib/api';
import { queryClient as qc } from '@/lib/query';

export type NavCounterKey =
  | 'splitPlansPendingReview'
  | 'offersAwaitingSalesRep';

export type TNavCounters = Partial<Record<NavCounterKey, number>>;

export const navCounterKeys = {
  all: ['nav-counters'] as const,
};

export function useNavCounters() {
  return useQuery(
    {
      queryKey: navCounterKeys.all,
      queryFn: () =>
        call('nav-counters', { method: 'GET' }).then(
          (r) => r.json() as Promise<TNavCounters>,
        ),
      staleTime: 30_000,
      refetchInterval: 60_000,
      refetchIntervalInBackground: false,
    },
    qc,
  );
}

export const invalidateNavCounters = () =>
  qc.invalidateQueries({ queryKey: navCounterKeys.all });
